import { Data } from './Data'

export enum IMAXAErrorCodes {
	ERR_UNAUTHORIZED = 501,
	ERR_BAD_REQUEST = 502,
	ERR_MISSING_PARAMETERS = 503,
	ERR_INTERNAL_ERROR = 504,
	ERR_NOT_OK = 505,
	ERR_TIME_OUT_OF_SYNC = 506,
	ERR_BULLSHIT_DATA = 507,
	ERR_NO_SUCH_CONTEXT = 508,
	ERR_CONNECTION_UNAVAILABLE = 509,
	ERR_BAD_RECONNECT = 510,
	ERR_BANNED = 511,
	ERR_SESSION_TIMED_OUT = 512
}

export enum PlayboardMode {
	NORMAL = "Normal",
	LESFIGURES = "LesFigures",
	LESFIGURES_PLUS = "LesFiguresPlus"
}

export enum IMAXALockLevel {
	UserLock = "UserLock",
	UserClose = "UserClose",
	Blocked = "Blocked",
	AwaitAuth = "AwaitAuth",
	Handpay = "Handpay",
	LockProvider = "LockProvider",
	LockHost = "LockHost",
	System = "System",
	SystemClose = "SystemClose",
	All = "All"
}

export enum IMAXAState {
	ERROR = "Error",
	INIT = "Init",
	IDLE = "Idle",
	BETS_OPEN = "BetsOpen",
	BETS_CLOSED = "BetsClosed",
	RESULT = "Result",
	PRESENT_WIN = "PresentWins",
	FEATURE = "Feature"
}

export enum IMAXASubState{
	NONE = 0,
	GAMBLE = 1,
	FREESPINS = 2
}

export class IMAXAServerMessage {
	constructor(rawData: any) {
		this.type = rawData.type as string
		this.sentTS = rawData.sentTS as number
		this.contextID = rawData.contextID as number
		this.payload = rawData.payload
		this.executionTime = rawData.executionTime as number
	}
	public type: string
	public contextID: number
	public sentTS: number
	public payload: any
	public receivedTS: number
	public executionTime: number
}

export class IMAXAClientMessage {
	constructor(rawData: any) {
		this.type = rawData.type as string
		this.sentTS = rawData.sentTS as number
		this.contextID = rawData.contextID as number
		this.payload = rawData.payload
	}
	public type: string
	public contextID: number
	public sentTS: number
	public payload: any
	public receivedTS: number
}


export class IMAXAGameStateChangedEvent extends IMAXAServerMessage implements gameStateChanged {
	name: "gameStateChanged"
	contextID = Data.Number(this, "contextID")
	data = Data.Object<gameStateChanged["data"]>(this, "data", class extends Data {
		name = Data.String(this, "name")
		old = Data.Number(this, "old")
		new = Data.Number(this, "new")
	})
}

export class IMAXAVoidEvent extends IMAXAServerMessage implements voidEvent {
	name: "void"
	contextID = Data.Number(this, "contextID")
	data = Data.Object<voidEvent["data"]>(this, "data", class extends Data {
		reason = Data.String(this, "reason")
		balance = Data.Object<any["balance"]>(this, "balance", class extends Data {

		})
		message = Data.String(this, "message")
		state = Data.Object<any["state"]>(this, "state", class extends Data {

		})
	})
}

export class IMAXAAuthenticationRequestEvent extends IMAXAServerMessage implements authenticationRequest {
	contextID = Data.Number(this, "contextID")
	name: 'authentication-request'
}

export class IMAXALockEvent extends IMAXAServerMessage implements lock {
	contextID = Data.Number(this, "contextID")
	name: 'lock'
	message = Data.String(this, "message")
	reason = Data.String(this, "reason")
}

export class IMAXAUnlockEvent extends IMAXAServerMessage implements unlock {
	contextID = Data.Number(this, "contextID")
	name: 'unlock'
}

export class IMAXAError extends IMAXAServerMessage {
	constructor(rawData: any) {
		super(rawData);
		this.type = rawData.payload.type;
		this.code = rawData.payload.code;
		this.message = rawData.payload.message;
		this.context = rawData.payload.context;
	}

	type: string
	code: number
	message: string
	context: string
}

export enum TransactionSource {
	Game = "Game",
	Bonus = "Bonus",
	External = "External",
	Jackpot = "ProgressiveJackpot"
}

export type Init = {
	version: {
		major: number,
		minor: number,
		revision: number
	}
}

export type event = {
	name: string
	triggered: number
	data: any
}

export type ping = {
	readonly name: "ping"
	data: {}
	triggered: string
}

export type history = {
	readonly name: "history"
	data: {}
}

export type authenticationRequest = {
	readonly name: "authentication-request"
}

export type lock = {
	reason: IMAXALockLevel
	message: string
}

export type session = {
	old: string
	new: string
}

export type gamePhase = {
	readonly name: "gamePhase"
	data: {}
}

export type gameStateChanged = {
	readonly name: "gameStateChanged"
	contextID: number
	data: {
		name: string
		old: number
		new: number
	}
}

export type voidEvent = {
	readonly name: "void"
	contextID: number
	data: {
		reason: string
		balance: number[]
		message: string
		state: any
	}
}

export type ResponseType = {
	type: "response"
	contextID: number
	payload: {

	}
	sentTS: number
}

export type BalanceUpdate = {
	source: TransactionSource
	old: number[]
	new: number[]
}

export type request = {
	type: "request"
	payload: {
		request: string
		ID: number
		data: string | string[] | {}
	}
	sentTS: number
}

export type betType = {
	index: number
	multiplier: number
	name: string
}

export type betTableEntry = {
	numbers: Array<number>
	type: number
}

export type bufferedMessage = {
	uniqueID: number,
	message: IMAXAClientMessage,
	callback: IMAXAMessageCallback,
	callbackTimeoutID: any
}

export type Transaction = {
	credits: number[]
	gid?: number
	id?: number
	result?: number
	source: string
}

export type TimeSyncPayload = {
	clientSent: number,
	serverReceived: number
}

export type Cookie = {
	name: string,
	value: string,
	options: string[]
}

export type IMAXAQuestion = {
	type: "question"
	payload: IMAXAQuestionPayload
}

export enum IMAXAQuestionType {
	choice = "choice",
	input = "input"
}

export type IMAXAQuestionPayload = {
	ID: number,
	topic: string,
	type: IMAXAQuestionType,
	question: string,
	payload: choice_question | input_question
}

export type choice_question = IMAXAQuestionPayload & {
	minNumChoices: number
	maxNumChoices: number,
	choices: Array<choice>
}

type choice = {
	title: string,
	description: string,
	data: object,
	originalIndex?: number
}

export type questionResponse = {
	question: number, // Enak question ID ki smo ga dobili
	answer: number[] // Odvisno od question type, če je choice je odgovor array indexov ki jih je player izbral
}

export type questionStakeData = {
	betTypeMax: number[],
	betTypeMin: number[],
	chipValues: number[],
	maxNumBets: number,
	maxWin: number,
	playboardMax: number,
	playboardMin: number
}

export type input_question = IMAXAQuestionPayload & {
	inputStyle: "text" | "int" | "float"
}

export type ChatReceivedMessage = {
	from: string,
	msg: string,
	private: boolean
	to?: string
}

export type PlayerInfo = {
	id: string,
	nickname?: string,
	number: number
}

export type IMAXAMessageCallback = (ok: boolean, response: IMAXAServerMessage) => void

export type JackpotLevel = {
	status: string,
	pot: number,
	minBet?: number,
	percentage?: number,
	name?: string,
	canBeWon?: boolean
}

export enum JackpotStatus {
	DISABLED = "Disabled",
	COUNTING = "Counting",
	WON = "Won"
}

/*==============AUTHENTICATION / INITIAL SETTINGS==============================*/
export interface GameConfig { };//Since game configs are dynamic,we extend 	   //
export type Authenticated = {												   //
	balance: number[],														   //
	currency: string,														   //
	denomination: number,													   //
	game: GameConfig,														   //
	history: Array<HistorySnapshot>,										   //
	account:																   //
	{										  								   //
		UID: string,														   //
		name: string,														   //
		nickname: string,													   //
		session: string,													   //
		demo: boolean,														   //
		payoutEnabled: boolean,												   //
		logoutSupported: boolean,											   //
		showUsername: boolean,												   //
		settings?: object //chatEnabled										   //
	}																		   //
	provider: {																   //
		config: any,														   //
		domain: string,														   //
		id: number,															   //
		type: number,														   //
		name: string,														   //
		authenticationRequired: boolean										   //
	},																		   //
	host:{																	
		info:{
			RNGType: string,
			doubleZero: boolean,
			stakeChangeAllowed: boolean,
			startVoteEnabled: boolean,
			roundTime: number
		},
		type:number
	}
	,												  						   //
	payoutEnabled: boolean,													   //
	currencyValue: number,												       //
	pilotSeat: boolean,												           //
	spectator: boolean,												           //
	locale: string															   //
};												   							   //
/*=============================================================================*/

/*======================UNFINISHED GAME SNAPSHOT=======================*/
export type HistorySnapshot = {
	balance: {
		before: number[]
		after: number[]
	}
	totalBet: number[]
	totalWin: number[]
    startT: number
    endT: number
	gid: string
	aid: string
	host: string
	data: {
		betPresets: object,
		bets: number[][],
		gameID: number,
		doubleZero: boolean,
		chipValues: number[]
	}
	randoms: number[]
	void: boolean
	transactions: Array<Transaction>
}
/*=====================================================================*/

/*======================PILOT SEAT REMOTE ACTIONS======================*/
//list of action types
export enum ActionType {
	Exit = "Exit",
	Bet = "Bet",
	RequestInfo = "RequestInfo",
	Chat = "Chat",
	GameAction = "GameAction",
	Withdraw = "Withdraw"
}
//how YServer triggers one of our available actions
export type RemotelyTriggeredAction = {
	type: string, //action name (ex. "bet")
	action?: string, //subAction name if any (ex. "maxBet")
	context?: any
}
export type Action = {
	type: string,
	actions?: Map<string, SubAction>,
	onlySubactions: boolean,
	enabled?: boolean,
	requiredContext?: any, //action template for the server (params we require to execute triggerFunction)
	enableFunction?: () => boolean,
	triggerFunction?: (context?) => void
}
export type SubAction = {
	name: string,
	enabled: boolean,
	requiredContext?: any, //action template for the server (params we require to execute triggerFunction)
	enableFunction?: () => boolean,
	triggerFunction?: (context?) => void
}
/*=====================================================================*/